import { Action, Dispatch } from 'redux'
import { FirebaseDocRefType, FirebaseTimestamp } from 'firebase/index'
import { push } from 'connected-react-router'
import { ShoppingBagType } from 'types/store'
import { hideLoadingAction, showLoadingAction } from 'reducks/loading/actions'
import { updateShoppingBagsAction } from 'reducks/store/actions'

const saveShoppingBags = (shoppingBags: ShoppingBagType[], storeRef: FirebaseDocRefType, isAdmin?: boolean) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(showLoadingAction())
    const now = FirebaseTimestamp.now()
    return storeRef
      .update({ shopping_bags: shoppingBags, updated_at: now })
      .then(() => {
        dispatch(hideLoadingAction())
        dispatch(updateShoppingBagsAction(shoppingBags))
        if (isAdmin) {
          dispatch(push('/admin/shops'))
        } else {
          dispatch(push('/account/settings'))
        }
      })
      .catch((error: unknown) => {
        dispatch(hideLoadingAction())
        console.error(error)
      })
  }
}

export default saveShoppingBags
